<template>
  <v-app>
    <header class="app-header" :class="{ scrolled: isScrolled }">
      <div class="header-inner">
        <router-link to="/" class="logo">
          <img :src="smilefileLogo" alt="SmileFile" class="logo-img" />
          <span class="sr-only">SmileFile</span>
      </router-link>

        <div class="header-claim">für Kunden der WaizmannTabelle kostenlos</div>
        <div class="header-actions"></div>
      </div>
    </header>

    <main class="app-main">
      <router-view />
    </main>

    <footer class="app-footer">
      <div class="footer-inner">
        <span>&copy; {{ new Date().getFullYear() }} SmileFile · WaizmannTabelle</span>
      </div>
    </footer>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import smilefileLogo from '@/assets/smilefile.png'

const isScrolled = ref(false)

function handleScroll () {
  const offset = window.pageYOffset || document.documentElement.scrollTop
  isScrolled.value = offset > 24
}

onMounted(() => {
  handleScroll()
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
:global(body) {
  background-color: #f4f6f8;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.v-application {
  background: #f4f6f8;
}

.app-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid rgba(15, 31, 47, 0.08);
  backdrop-filter: blur(10px);
  transition: box-shadow 0.2s ease;
}

.app-header.scrolled {
  box-shadow: 0 12px 30px rgba(15, 31, 47, 0.12);
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 14px 24px;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  max-height: 48px;
  width: auto;
  display: block;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-claim {
  color: #1aa6e8;
  font-weight: 600;
  font-size: 1.05rem;
  text-transform: none;
  text-align: right;
}

.cta-button {
  text-transform: none;
  background: #1aa6e8 !important;
}

.language-button {
  min-height: 40px;
  gap: 8px;
  padding: 0 18px;
}

.language-icon {
  margin-right: 2px;
}

.app-main {
  min-height: calc(100vh - 180px);
}

.app-footer {
  border-top: 1px solid rgba(15, 31, 47, 0.08);
  padding: 18px 24px;
  text-align: center;
  background: #ffffff;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  color: #495463;
}
</style>

<style>
.v-btn {
  text-transform: none !important;
  border-radius: 6px !important;
  background-color: #1aa6e8 !important;
  color: #ffffff !important;
}

.v-btn .v-icon {
  color: #ffffff !important;
}
</style>
